export enum AffiliatePartnerAPI {
  HOST = "/partner",
  SAVE = "/savePartner", // POST
  DELETE = "/deletePartner", // DELETE
}
